module.exports = __webpack_public_path__ + "images/psp/ATV/preparing-atv-for-storage.png";